import Vue from 'vue';
import App from './App.vue';
import router from './router';

import Amplify from 'aws-amplify';
import { AMPLIFY_CONFIG } from '@/assets/src/amplify/amplify_configs';

import store from './store';

Vue.config.productionTip = false;

Amplify.configure(AMPLIFY_CONFIG);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
